import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import numeral from 'numeral';
import { Account } from '../../../../models/customer';
import { SinglePaymentRouteSettings } from '../../../../models/single-payment/single-payment-route-settings';
import { SelectedAccountsSettings } from '../selected-accounts-settings';
import { State } from '../../../../services/global-state';
import { NumberHelper } from '../../../../smart/helpers/number-helper';

@autoinject
export class CardPayInFull {
	selectedAccounts: Array<Account> = [];
	selectedAccountsSettings: SelectedAccountsSettings;
	balance: number = 0;
	discount: number = 0;
	total: number = 0;
	customLabel: string;

	constructor(private state: State, private router: Router) {
	}

	activate(model) {
		if (!!model) {
			this.selectedAccounts = model.selectedAccounts;
			this.selectedAccountsSettings = model.selectedAccountsSettings;
			this.calculateDiscount();
			this.customLabel = this.state.business.portalSettings.fields.payInFull.label;
		}
	}

	calculateDiscount() {
		this.discount = 0;

		this.selectedAccounts.forEach(account => {
            if(account.balance > 0) {
                this.balance += account.balance;
                let balanceRanges = this.selectedAccountsSettings.installmentBalanceRanges[account.id];
                if (balanceRanges && this.selectedAccountsSettings.allowInstallments) {
                    let accountDiscount = 0;
                    balanceRanges.forEach((range) => {
                        if (account.balance >= range.min && account.balance <= range.max) {
                            let rangeDiscount = parseInt(range.payInFullDiscountPercent || 0, 10);
                            if (accountDiscount < rangeDiscount) {
                                accountDiscount = rangeDiscount;
                            }
                        }
                    });

					let discountedTotal = NumberHelper.parseCurrency((account.balance * (1 - accountDiscount / 100)).toFixed(2));
                    this.total += discountedTotal;
                } else {
                    // No discounts for account
                    this.total += account.balance;
                }
            }
		});

		this.discount = (1 - this.total / this.balance) * 100; // Get total discount percentage
		this.discount = numeral(this.discount.toFixed(2)).value(); // Fix rounding errors
	}

	goToMakePayment() {
		let routeSettings: SinglePaymentRouteSettings = new SinglePaymentRouteSettings();
		routeSettings.payInFull = true;
		routeSettings.selectedCustomerAccountKeys = this.selectedAccounts.map(x => x.customerAccountKey);
		this.router.routes.find((routeConfig) => routeConfig.name === 'single-payment/single-payment').settings = routeSettings;
		this.router.navigateToRoute('single-payment/single-payment');
	}
}
